import React from 'react';
import { Stack, Shimmer } from '@fluentui/react';

export const BidStrategyShimmer = () => (
  <Stack tokens={{ childrenGap: 16 }}>
    <Shimmer />
    <Shimmer width="75%" />
    <Shimmer width="50%" />
  </Stack>
);
